'use es6';

import * as RequestState from 'FormsCommonComponents/lib/RequestState';
import * as Actions from '../actions/LeadFlows';
const INIT_STATE = {
  definition: {},
  definitionRequestState: RequestState.NOT_REQUESTED
};
export function leadFlows(state = INIT_STATE, action) {
  switch (action.type) {
    case Actions.REQUEST_LEADFLOW_DEFINITION:
      return Object.assign({}, state, {
        definitionRequestState: RequestState.REQUESTED,
        definition: {}
      });
    case Actions.SUCCEED_REQUESTING_LEADFLOW_DEFINITION:
      return Object.assign({}, state, {
        definitionRequestState: RequestState.SUCCEEDED,
        definition: action.res
      });
    case Actions.FAILED_REQUESTING_LEADFLOW_DEFINITION:
      return Object.assign({}, state, {
        definitionRequestState: RequestState.FAILED
      });
    default:
      return state;
  }
}